module.exports = __webpack_public_path__ + "static/img/2.9513113.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/eng/2.png
// module id = gIC1
// module chunks = 0